// How many days before and after an anomaly can be displayed.
export const RANGE_DAYS = [3, 7];
